// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
 
  
  baseUrl: 'https://corporateapps-stage.oa.caiso.com/StageSubscriptionApi',
    //     baseUrl: 'http://fentapps03.oa.caiso.com/MapStageSubscriptionApi',
    //    baseUrl: 'https://fentapps03.oa.caiso.com/StageSubscriptionApi',

  //         baseUrl: 'http://fentapps03.oa.caiso.com/TrainSubscriptionApi',
//   baseUrl: 'http://fentappt03.oa.caiso.com/MapTestSubscriptionApi',
 //   baseUrl: 'http://fentappt03.oa.caiso.com/TestSubscriptionApi',
//  baseUrl: 'http://fcorpsups05.oa.caiso.com/DevSubscriptionApi',
// baseUrl: 'https://localhost:44310',
 //  sourceId:'caiso.com',
   sourceId:'wem',
 // sourceId:'caisostage.com',
  //  sourceId:'rcwest',
   //   sourceId:'mediabriefing',
 // sourceId:'eea',
  isOrgNameMandatory:false,
  noIsoEmail:false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
